import { QueryKeys } from "@sso/constant";
import { SearchObject, SearchParameterKeys, SortColumn, SortKeys } from "@sso/types";

export const queryBuilder = (pageSize: number, pageIndex: number, searchObject?: SearchObject, sort?: SortColumn) => {
  const query = new URLSearchParams();
  query.set(QueryKeys.PAGE_SIZE, String(pageSize));
  query.set(QueryKeys.PAGE_INDEX, String(pageIndex));

  if (searchObject) {
    const filterQuery = Object.values(searchObject)
      .map(search => {
        if (search.parameter === SearchParameterKeys.BETWEEN) {
          // Check if both startValue and endValue are defined
          if (search.startValue && search.endValue) {
            return `${search.column} ${SearchParameterKeys.GREATER_THAN_OR_EQUAL} ${search.startValue} _and ${search.column} ${SearchParameterKeys.LESS_THAN_OR_EQUAL} ${search.endValue}`;
          }
          // If only endValue is defined, default to a less than or equal filter
          if (search.endValue) {
            return `${search.column} ${SearchParameterKeys.LESS_THAN_OR_EQUAL} ${search.endValue}`;
          }
          // If only startValue is defined, default to a greater than or equal filter
          if (search.startValue) {
            return `${search.column} ${SearchParameterKeys.GREATER_THAN_OR_EQUAL} ${search.startValue}`;
          }

          return "";
        } else {
          if (search.nullable && search.value === "N/A") {
            return `${search.column} is null`;
          } else {
            return `${search.column} ${search.parameter || SearchParameterKeys.CONTAIN} ${search?.value}`;
          }
        }
      })
      .join(" _and ");
    filterQuery.length && query.set(QueryKeys.FILTER, filterQuery);
  }
  if (sort && sort.type !== SortKeys.NONE && !sort.multiField) {
    query.set(QueryKeys.ORDER_BY, `${sort.column}${sort.type === SortKeys.DESC ? " desc" : ""}`);
  } else if (sort && sort.multiField) {
    const sortQuery = sort.multiField
      .map(column => `${column}${sort.type === SortKeys.DESC ? " desc" : ""}`)
      .join(", ");
    query.set(QueryKeys.ORDER_BY, sortQuery);
  }
  return query.toString();
};
